module.exports = __webpack_public_path__ + "static/img/190405-feature-pic.8c20e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190405-feature-pic.jpg
// module id = KFal
// module chunks = 0